let _this;
import scrollLoadList from '../commonComponents/scrollLoadList.vue'
function hideTransfer(e){
  if($(e.target).parents('#add_options').length <= 0){
    _this.shrinkBox();
  }
}
export default {
  name: "add-options",
  components:{scrollLoadList},
  props:{
    // 新增项标题
    titleText:{
      type:String,
      default:'Asset'
    },
    /*table中批量选择的数据*/
    panelList:{
      type:Array,
      default(){
        return [];
      }
    },
    // 查询数据方法，在ShareApi中获取
    funStr:{
      type:String,
      default:'getAssetList'
    },
    // 显示字段
    viewField:{
      type:String,
      default:'name'
    },
    // 搜索项
    searchField:{
      type:String,
      default:'name'
    },
    // 排序字段
    sortName:{
      type:String,
      default:'name'
    },
    // 搜索项提示
    placeHolderTxt:{
      type:String,
      default:'Search'
    },
    //是否批量打印卡
    isPrintCard:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return{
      inputValue:'',
      checkedList:[],/*已选择数据*/
      optionList:[],/*查询数据*/
      curPage:1,
      pageCount:1,/*页码总数*/
      timer:'',
      originList:[],
      checkTimer:''
    }
  },
  mounted(){
    _this = this;
    _this.initData();
    initDraggable();
    $(document).bind('click',hideTransfer);
  },
  beforeDestroy(){
    $(document).unbind('click',hideTransfer);
  },
  methods:{
    shrinkBox:function () {
      $('#option-panel').slideUp(300);
      $('.panel-data-list').slideUp(300);
    },
    openAddSetting:function (e) {
      _this.inputValue = '';
      _this.curPage = 1;
      _this.optionList = [];
      _this.queryData();
      $('#option-panel').slideDown(300);
      $('#option-panel').css({top:'unset',left:'unset'});
    },
    // 数据初始化
    initData:function () {
      _this.originList = JSON.parse(JSON.stringify(_this.panelList));
      _this.checkedList = JSON.parse(JSON.stringify(_this.panelList));
    },
    shrinkPanel:function (e) {
      $(e.target).parents('.batch-select-box').find('.panel-data-list').slideToggle(300);
      $('.batch-select-box').toggleClass('ivu-select-visible');
    },
    handleSearch:function () {
      clearTimeout(_this.timer);
      _this.timer = setTimeout(function () {
        _this.curPage = 1;
        _this.optionList = [];
        $('.panel-data-list').slideDown(300);
        _this.queryData();
      },500);
    },
    queryData:function (){
      let params = {};
      if(_this.isPrintCard){
        params = {enabledPaging:true,page:_this.curPage,perPage:20,cardExtension:{[this.searchField]:_this.inputValue},sortName:this.sortName,sortType:1};
      }else {
        params = {enabledPaging:true,page:_this.curPage,perPage:20,[this.searchField]:_this.inputValue,sortName:this.sortName,sortType:0};
      }
      _this.shareApi[_this.funStr](params).done(result =>{
        _this.pageCount = result.pageCount;
        if(_this.isPrintCard){
          let cardList = [];
          result.items.forEach(item=> {
            item.cardExtensions.forEach(card => {
              if (card.type === _this.ApiService.cardSettingInfo.mainType) {
                cardList.push({id: item.cardId, displayCard: card.type + '-' + card.no})
              }
            })
          })
          result.items.forEach(item =>{
            let flag = _this.originList.some(option =>option.id === item.cardId);
            if(flag){
              _this.$set(item,'isOrigin',true);
            }
          });
          _this.optionList = _this.optionList.concat(cardList);
        }else {
          result.items.forEach(item =>{
            let flag = _this.originList.some(option =>option.id === item.id);
            if(flag){
              _this.$set(item,'isOrigin',true);
            }
          });
          _this.optionList = _this.optionList.concat(result.items);
        }
      });
    },
    // 滚动至底部数据更新
    updateData:function () {
      if(_this.curPage >= _this.pageCount){
        return;
      }
      clearTimeout(this.queryTimer);
      this.queryTimer = setTimeout(()=>{
        _this.curPage ++;
        _this.queryData();
      },500);
    },
    checkOption:function (item) {
      clearTimeout(_this.checkTimer);
      _this.checkTimer = setTimeout(function () {
        let index = _this.checkedList.findIndex(option => item.id === option.id);
        if(index > -1){
          _this.checkedList.splice(index,1);
        }else{
          _this.checkedList.unshift(item);
        }
        _this.$emit('checkOption',_this.checkedList);
        $('.batch-set-list').scrollTop(0);
      },300);
    },
    clearValue:function () {
      _this.inputValue = '';
      this.handleSearch();
    }
  },
}
function initDraggable() {
  //移动面板
  $('#option-panel').draggable({});
}



// WEBPACK FOOTER //
// ./src/admin/components/userCommon/addOptions.js